






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Question from "@/components/Question.vue";
import RemainingTime from "@/components/RemainingTime.vue";
import ProgressBar from "@/components/progressbar/ProgressBar.vue";
import StartedAttemptModel from "@/model/StartedAttemptModel";
import AttemptModule from "@/store/AttemptModule";
import Slick from "vue-slick";
@Component({
  components: { Question, RemainingTime, ProgressBar, Slick }
})
export default class StartedAttempt extends Vue {
  @Prop()
  attempt!: StartedAttemptModel;
  @Prop()
  index: number = 0;
  @Prop()
  lastQuestionVisited: boolean = false;

  $refs!: {
    slick: Slick;
  };

  get currentQuestion() {
    return this.attempt.questions[this.index];
  }

  get hasNext() {
    return this.index < this.attempt.questions.length - 1;
  }

  get hasPrev() {
    return this.index > 0;
  }

  finishAttempt() {
    if (confirm("Opravdu si přejete dokončit test?")) {
      AttemptModule.finishAttempt(this.attempt);
    }
  }

  setQuestionIndex(index: number) {
    this.index = index;
  }

  get slickOptions() {
    return {
      centerMode: false,
      arrows: false,
      draggable: false,
      variableWidth: false,
      infinite: false,
      speed: 200,
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
            centerMode: true,
            variableWidth: true
          }
        }
      ]
    };
  }

  get indexCacheKey() {
    return "mojeznalosti-index-" + this.attempt.uid;
  }

  get cachedIndex(): number {
    const cachedIndex = localStorage.getItem(this.indexCacheKey) || "0";
    return parseInt(cachedIndex);
  }

  @Watch("index")
  onIndexChange(index: number) {
    localStorage.setItem(this.indexCacheKey, index.toString());
    this.lastQuestionVisited = this.lastQuestionVisited || !this.hasNext;
    this.$refs.slick.goTo(index);
  }

  mounted() {
    this.index = this.cachedIndex;
  }
}
